module.exports = __webpack_public_path__ + "assets/img/free_3.da6ef26a.png";